export const UNSUBSCRIBE_DELAY_MS = 200;

export function clearExistingTimeout(
  key: string,
  timeouts: Map<string, NodeJS.Timeout>,
): Map<string, NodeJS.Timeout> {
  const existingTimeout = timeouts.get(key);
  if (existingTimeout) {
    clearTimeout(existingTimeout);
    const newTimeouts = new Map(timeouts);
    newTimeouts.delete(key);
    return newTimeouts;
  }
  return timeouts;
}

export function clearAllTimeouts(timeouts: Map<string, NodeJS.Timeout>): void {
  timeouts.forEach((timeoutId) => clearTimeout(timeoutId));
}

export function scheduleUnsubscribeTimeout(
  callback: () => Promise<void>,
  delay: number,
): NodeJS.Timeout {
  return setTimeout(callback, delay);
}
